import React from 'react';
import './style.scss';
import Card from '../card';
import { formatNumber } from '../../assets/helper/num-helper';
import { UQLoaderProps } from '../loader';


export interface UQCardBigTextProps {
  value: any;
  loading?: boolean;
  className?: string;
  header?: string;
  icon?: string;
  iconColor?: string;
  fullNumber?: boolean;
  loaderProps?: UQLoaderProps;
}

const UQCardBigText: React.FC<UQCardBigTextProps> = ({
  value,
  fullNumber = false,
  loading = false,
  header,
  icon,
  iconColor,
  className = '',
  loaderProps,
}) => {
  const formattedValue = fullNumber ? formatNumber(value) : value;
  return (
    <Card
      loading={loading}
      header={header}
      icon={icon}
      iconColor={iconColor}
      className={className}
      loaderProps={loaderProps}
    >
      <div className="dashboard-big-number">{formattedValue}</div>
    </Card>
  );
};

export default UQCardBigText;
